import { Component, input } from '@angular/core';

import { CamRecord } from '../../../engine/models/record';
import { CamColumnConfig } from '../../../engine/types';

@Component({
  host: { 'data-cid': 'abstract-cell' },
  selector: '',
  template: ``,
})
export abstract class AbstractCellComponent<T> {
  record = input.required<CamRecord>();
  column = input.required<CamColumnConfig>();
  value = input<any>();
  data = input.required<T>();
}
